import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../settings';
import logo from '../../image/Caminos_logo_blanco.png'


export default ({ collapsed }) => {
  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div style={{width: '100%',height: '100%',display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
          <Link to="/dashboard">
            <img src={logo} style={{width:'80%'}} alt="CAMINOS DE LAS SIERRAS"/>
          </Link>
        </div>
      ) : (
        <div style={{width: '100%',height: '100%',display: 'flex',justifyContent: 'center',alignItems: 'center', padding:10}}>
          <Link to="/dashboard">
            <img src={logo} style={{width:'60%'}} alt="CAMINOS DE LAS SIERRAS"/>
          </Link>
        </div>
      )}
    </div>
  );
};
